module.exports = __webpack_public_path__ + "img/gepuzemeltetesi_elorejelzes_es_adat_elemzesek_pop_up.5460ead0.png";